module.exports = __webpack_public_path__ + "img/LUB00347.4661bf00.png";